"use client";

import React, { useState } from 'react';
import { Badge } from "flowbite-react";
import { Button, Select, Table, Typography, Pagination, Input } from 'antd'
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'Number',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Date',
    dataIndex: 'invoice_date',
    key: 'invoice_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <>{new Date(record.invoice_date).toLocaleDateString()}</>
  },
  
  {
    title: 'Customer',
    dataIndex: 'customer',
    key: 'customer',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-wrap font-medium dark:text-white',
    render: (_, record) => <Badge className={record.status === 'posted' ? "text-green-950 bg-green-100 w-max" : "text-red-950 bg-red-100 w-max"}>{record.status}</Badge>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/invoices/' + record.number.replaceAll('/', '-')}>
        Edit
      </Link>
    )
  }
]


const options = []
for (let i = 10; i < 36; i++) {
  options.push({
    value: i.toString(36) + i,
    label: i.toString(36) + i
  })
}
const handleChange = (value) => {
  console.log(`Selected: ${value}`)
}



const CustomerInvoices = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const invoices = useLoaderData();
  const [current, setCurrent] = useState(3);
  const navigate = useNavigate();

  const onChange = (page) => {
    console.log(page)
    setCurrent(page)
  }


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/accounting/invoices/'+record.number.replaceAll('/', '-'))
    };
  }


  return (
    <div>
      {/* <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Journal Entries</h3>
        <div class=" bg-white dark:bg-gray-900">
          <label for="table-search" class="sr-only">Search</label>
          <div class="relative mt-1">
            <div class="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
              </svg>
            </div>
            <input type="text" id="table-search" class="block pt-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search for items" />
          </div>
        </div>
      </div> */}
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Invoices</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            onChange={handleChange}
            className='w-96'
            options={options}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/invoices/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination current={current} onChange={onChange} total={50} />
          </div>
        </div>
      </div>
      <Table
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={invoices}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    </div>
  )
}

export default CustomerInvoices;